import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from 'react-admin';

const DatabaseItemFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
    </Filter>
);

const DatabaseItemList = props => (
    <List {...props} filters={<DatabaseItemFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="type" />
            <TextField source="hostname" />
            <TextField source="port" />
            <TextField source="version" />
            <TextField source="database_list" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default DatabaseItemList;